// W-0821 — Painel lateral com qtd e valor por cobrador atribuído (atualiza em tempo real).
// FE-003 — receber o slice já calculado pelo pai (selector granular).

import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import { formatarBRL } from '../helpers';

const PainelResumoCobradores = ({
  resumoAtribuicoes, // [{ codigo, quantidade, valor }]
  resumoCobradoresAtuais, // [{ codigo_cobrador, nome, quantidade, valor }] do backend (RxDBGrid2 paridade)
  cobradoresMap,
}) => (
  <Card className="mb-3">
    <Card.Header as="h6" className="bg-light">
      Resumo por cobrador
    </Card.Header>
    <Card.Body className="p-2">
      <div className="mb-2">
        <strong className="small">
          Atribuições em curso{' '}
          <Badge bg="success">{resumoAtribuicoes.length} cobrador(es)</Badge>
        </strong>
        <div className="table-responsive">
          <Table size="sm" striped className="mb-0">
            <thead>
              <tr>
                <th>Cobrador</th>
                <th className="text-right">Qtd</th>
                <th className="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              {resumoAtribuicoes.length === 0 && (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                    Nenhuma atribuição feita ainda.
                  </td>
                </tr>
              )}
              {resumoAtribuicoes.map((item) => (
                <tr key={`atrib-${item.codigo}`}>
                  <td>
                    {(cobradoresMap && cobradoresMap.get(item.codigo)) ||
                      `Cobrador ${item.codigo}`}
                  </td>
                  <td className="text-right">{item.quantidade}</td>
                  <td className="text-right">{formatarBRL(item.valor)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      {resumoCobradoresAtuais && resumoCobradoresAtuais.length > 0 && (
        <div>
          <strong className="small">Cobradores atuais (paridade Delphi)</strong>
          <div className="table-responsive">
            <Table size="sm" hover className="mb-0">
              <thead>
                <tr>
                  <th>Cobrador</th>
                  <th className="text-right">Qtd</th>
                  <th className="text-right">Valor</th>
                </tr>
              </thead>
              <tbody>
                {resumoCobradoresAtuais.map((item) => (
                  <tr
                    key={`atual-${item.codigo_cobrador || 'sem-cobrador'}-${
                      item.nome
                    }`}
                  >
                    <td>{item.nome || 'Sem cobrador'}</td>
                    <td className="text-right">{item.quantidade}</td>
                    <td className="text-right">{formatarBRL(item.valor)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </Card.Body>
  </Card>
);

export default PainelResumoCobradores;
